import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '@/components/shared/Sidebar';
import { LayoutDashboard, Users, Settings, Building2, Network, FileSpreadsheet, Coins, UserCog, BadgeCheck, LifeBuoy, MessageSquare, Cpu, Newspaper, Briefcase, MessageCircle, CreditCard } from 'lucide-react';
import AdminHome from './AdminHome';
import AdminUsers from './AdminUsers';
import AdminSettings from './AdminSettings';
import AdminOrgPortfolio from './AdminOrgPortfolio';
import AdminOrgHierarchy from './AdminOrgHierarchy';
import AdminReports from './AdminReports';
import AdminWallets from './AdminWallets';
import AdminStaffingOrgs from './AdminStaffingOrgs';
import AdminCandidates from './AdminCandidates';
import AdminSupportAgents from './AdminSupportAgents';
import AdminFeedback from './AdminFeedback';
import AdminLLM from './AdminLLM';
import AdminJobs from './AdminJobs';
import AdminReviews from './AdminReviews';
import AdminWhatsApp from './AdminWhatsApp';
import AdminPayments from './AdminPayments';
import { AdminBlogList, AdminBlogEditor } from './AdminBlog';
import ContactUs from '@/pages/ContactUs';

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/users', icon: Users, label: 'Users' },
  { to: '/admin/candidates', icon: UserCog, label: 'Candidates' },
  { to: '/admin/jobs', icon: Briefcase, label: 'All Jobs' },
  { to: '/admin/organizations', icon: Building2, label: 'Org Portfolio' },
  { to: '/admin/staffing-orgs', icon: BadgeCheck, label: 'Staffing Orgs' },
  { to: '/admin/support-agents', icon: LifeBuoy, label: 'Support Agents' },
  { to: '/admin/hierarchy', icon: Network, label: 'Org Hierarchy' },
  { to: '/admin/wallets', icon: Coins, label: 'Mu Points' },
  { to: '/admin/payments', icon: CreditCard, label: 'Payments' },
  { to: '/admin/feedback', icon: MessageSquare, label: 'Feedback' },
  { to: '/admin/reviews', icon: MessageSquare, label: 'Reviews' },
  { to: '/admin/blog', icon: Newspaper, label: 'Blog' },
  { to: '/admin/reports', icon: FileSpreadsheet, label: 'Reports' },
  { to: '/admin/llm', icon: Cpu, label: 'LLM Router' },
  { to: '/admin/whatsapp', icon: MessageCircle, label: 'WhatsApp' },
  { to: '/admin/settings', icon: Settings, label: 'Settings' },
];

export default function AdminDashboard() {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-[#0a0a0b]" data-testid="admin-dashboard">
      <Sidebar items={navItems} title="Admin" />
      <main className="flex-1 overflow-auto pt-14 lg:pt-0">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <Routes>
            <Route index element={<AdminHome />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="candidates" element={<AdminCandidates />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="organizations" element={<AdminOrgPortfolio />} />
            <Route path="staffing-orgs" element={<AdminStaffingOrgs />} />
            <Route path="support-agents" element={<AdminSupportAgents />} />
            <Route path="hierarchy" element={<AdminOrgHierarchy />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="wallets" element={<AdminWallets />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="feedback" element={<AdminFeedback />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="blog" element={<AdminBlogList />} />
            <Route path="blog/new" element={<AdminBlogEditor />} />
            <Route path="blog/:postId" element={<AdminBlogEditor />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="llm" element={<AdminLLM />} />
            <Route path="whatsapp" element={<AdminWhatsApp />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="contact/ticket/:ticketId" element={<ContactUs />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
